import { render, staticRenderFns } from "./add-book.vue?vue&type=template&id=3e3b4f72&scoped=true&"
import script from "./add-book.vue?vue&type=script&lang=js&"
export * from "./add-book.vue?vue&type=script&lang=js&"
import style0 from "./add-book.vue?vue&type=style&index=0&id=3e3b4f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b4f72",
  null
  
)

export default component.exports